// extracted by mini-css-extract-plugin
export default {"container":"pagenot_container__EY05Z"};